// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".learner__name[data-v-8ac56874]{color:var(--primary)}.learner__email[data-v-8ac56874]{font-size:12.16px}", ""]);
// Exports
module.exports = exports;
